export const getProfile = (id) => {
    switch (id) {
        case 1:
            return 'Administrador'
        case 2:
            return 'Líder ESG'
        case 3:
            return 'Respondente'
        case 4:
            return 'Avesso'
        case 5:
            return 'Suzano'
        case 6:
            return 'Tradutor'
        case 7:
            return 'Auditor'
        default:
            return 'Auditor'
    }
}

export const getStep = (param) => {
    switch (param) {
        case 'draft':
            return 'Respondente/Rascunho'
        case 'draft_en':
            return 'Tradutor'
        case 'approval_esg':
            return 'Líder ESG'
        case 'evaluation_avesso':
            return 'Avaliação - Avesso'
        case 'evaluation_suzano':
            return 'Avaliação - Suzano'
        case 'evaluation_suzano_en':
            return 'Avaliação - Suzano EN'
        case 'finished':
            return 'Publicar PT'
        case 'finished_en':
            return 'Publicar EN'
        default:
            return 'Respondente/Rascunho'
    }
}

export const tagsSystem = [
    {
        label: 'Temas Materiais',
        value: 'temas_materiais'
    },
    {
        label: 'Hashtag',
        value: 'hashtag'
    },
    {
        label: 'ODS',
        value: 'ods'
    },
    {
        label: 'Dimensão GRI',
        value: 'dimensao_gri'
    },
    {
        label: 'Código GRI',
        value: 'codigo_gri'
    },
    {
        label: 'Dimensão SASB',
        value: 'dimensao_sasb'
    },
    {
        label: 'Código SASB',
        value: 'codigo_sasb'
    },
    {
        label: 'Setor SASB',
        value: 'setor_sasb'
    },
    {
        label: 'Dimensão Métrica do capitalismo Stakeholder',
        value: 'dim_m_c_stakeholder'
    },
    {
        label: 'TCFD',
        value: 'tcfd'
    },
    {
        label: 'Compromissos',
        value: 'flag_compromissos'
    }
]

export const optionsRespondent = [
    {
        label: 'Líder ESG',
        value: 'approval_esg'
    }
]

export const optionsSuzano = [
    {
        label: 'Respondente/Rascunho',
        value: 'draft'
    },
    {
        label: 'Líder ESG',
        value: 'approval_esg'
    },
    {
        label: 'Avaliação - Avesso',
        value: 'evaluation_avesso'
    },
    {
        label: 'Publicar PT',
        value: 'finished'
    },
    {
        label: 'Rascunho EN',
        value: 'draft_en'
    },
    {
        label: 'Publicar EN',
        value: 'finished_en'
    }
]

export const optionsAvesso = [
    {
        label: 'Respondente/Rascunho',
        value: 'draft'
    },
    {
        label: 'Líder ESG',
        value: 'approval_esg'
    },
    {
        label: 'Avaliação - Suzano',
        value: 'evaluation_suzano'
    }
]

export const optionsLeader = [
    {
        label: 'Respondente/Rascunho',
        value: 'draft'
    },
    {
        label: 'Avaliação - Avesso',
        value: 'evaluation_avesso'
    }
]

export const optionsGoalPT = [
    {
        label: 'Rascunho PT',
        value: 'draft_pt'
    },
    {
        label: 'Aprovação PT',
        value: 'approved_pt'
    },
    {
        label: 'Publicar PT',
        value: 'finished_pt'
    }
]

export const optionsGoalEN = [
    {
        label: 'Rascunho EN',
        value: 'draft_en'
    },
    {
        label: 'Aprovação EN',
        value: 'approved_en'
    },
    {
        label: 'Publicar EN',
        value: 'finished_en'
    },
]

export const optionsAdminPt = [
    {
        label: 'Respondente',
        value: 'draft',
        lang: 'pt-BR'
    },
    {
        label: 'Líder ESG',
        value: 'approval_esg',
        lang: 'pt-BR'
    },
    {
        label: 'Avaliação - Avesso',
        value: 'evaluation_avesso',
        lang: 'pt-BR'
    },
    {
        label: 'Avaliação - Suzano',
        value: 'evaluation_suzano',
        lang: 'pt-BR'
    },
    {
        label: 'Publicado',
        value: 'finished',
        lang: 'pt-BR'
    },
    {
        label: 'Tradutor',
        value: 'draft_en',
        lang: 'en-US'
    },
    {
        label: 'Avaliação - Suzano',
        value: 'evaluation_suzano_en',
        lang: 'en-US'
    },
    {
        label: 'Publicado',
        value: 'finished_en',
        lang: 'en-US'
    }
]

export const optionsDefault = [
    {
        label: 'Respondente',
        value: 'draft',
        lang: 'pt-BR'
    },
    {
        label: 'Líder ESG',
        value: 'approval_esg',
        lang: 'pt-BR'
    },
    {
        label: 'Avaliação - Avesso',
        value: 'evaluation_avesso',
        lang: 'pt-BR'
    },
    {
        label: 'Avaliação - Suzano',
        value: 'evaluation_suzano',
        lang: 'pt-BR'
    },
    {
        label: 'Publicado',
        value: 'finished',
        lang: 'pt-BR'
    },
    {
        label: 'Tradutor',
        value: 'draft_en',
        lang: 'en-US'
    },
    {
        label: 'Avaliação - Suzano',
        value: 'evaluation_suzano_en',
        lang: 'en-US'
    },
    {
        label: 'Publicado',
        value: 'finished_en',
        lang: 'en-US'
    }
]

export const optionsTranslate = [
    {
        label: 'Avaliação - Suzano EN',
        value: 'evaluation_suzano_en'
    }
]
export const optionsSuzanoEn = [
    {
        label: 'Tradutor',
        value: 'draft_en'
    },
    {
        label: 'Publicar EN',
        value: 'finished_en'
    }
]
